// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__4J1c2","col":"styles_col__91xss","fulfillmentStatus":"styles_fulfillmentStatus__GvdJ1","emailCol":"styles_emailCol__2rO8V"};